import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 87px;
  height: 94px;
`;

export const ArrowContainer = styled.div<{ width: number; height: number }>`
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .arrow {
    transition: all 0.4s ease;
    z-index: 1;
  }

  &[data-status='active'] {
    .arrow {
      opacity: 1;
    }
  }

  &[data-status='inactive'] {
    .arrow {
      opacity: 0;
    }
  }

  .arrow-down-yellow {
    transform: rotate(180deg);
  }
`;
